import React from 'react'
import Link from 'gatsby-theme-kn/src/components/atoms/Link'
import { useTranslation } from 'react-i18next'

const SidebarGriModule = ({ gri_numbers }) => {
  const { t } = useTranslation()
  return (
    <div className="sidebar-module">
      <div className="sidebar-module-container">
        <Link className="sidebar-link" link={`${t('sidebar_gri.index_link')}`}>
          <span className="sidebar-link-title">GRI Index</span>
        </Link>

        {gri_numbers.map((gri_number, index) => (
          <div
            className="sidebar-gri"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title={gri_number.content?.description}
            key={index}
          >
            <span className="sidebar-gri-title">
              GRI: {gri_number.content?.name}
            </span>
            <span className="sidebar-gri-description">
              {gri_number.content?.description}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default SidebarGriModule
